import { useContext, useLayoutEffect, useState } from "react";
import Footerr from "../../components/Footerr";
import NavBar from "../../components/Navbarr";
import "./index.scss";
import { UserContext } from "../../components/context/userContext";
import AccessDenied from "../../components/AccessDenied";
import SideBarAdmin from "../../components/SideBarAdmin";
import KpiCard from "../../components/KpiCard";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

/* ✅ STATIC KPIS (for now) */
const kpis = [
  {
    name: "Incoming orders",
    value: 18,
    percent: 12,
    data: [5, 8, 10, 12, 14, 16, 18],
  },
  {
    name: "Delivered orders",
    value: 47,
    percent: 8,
    data: [15, 18, 20, 28, 35, 42, 47],
  },
  {
    name: "Total sales",
    value: "12,450 DT",
    percent: 22,
    data: [3000, 4200, 5000, 6200, 8000, 9500, 12450],
  },
  {
    name: "Active promotions",
    value: 6,
    percent: -5,
    data: [8, 8, 7, 7, 7, 6, 6],
  },
];

const DashBoardAdmin = () => {
  const { user } = useContext(UserContext);
  const { width } = useWindowDimensions();

  return (
    <>
      {user?.role == 1 ? (
        <div>
          <NavBar />

          <div className="dashboard-container">
            <div className="side-bar-container">
              <SideBarAdmin widthWindow={width} screen={"home"} />
            </div>

            <div className="body-container-kpis">
              {kpis?.map((kp, index) => (
                <div key={kp?.name || index} className="card-kpis">
                  <KpiCard
                    name={kp.name}
                    value={kp.value}
                    percent={kp.percent}
                    data={kp.data}
                  />
                </div>
              ))}
            </div>
          </div>

          <Footerr />
        </div>
      ) : (
        <div>
          <NavBar />
          <div className="dashboard-container">
            <AccessDenied />
          </div>
          <Footerr />
        </div>
      )}
    </>
  );
};

export default DashBoardAdmin;
